const lang = {
    ja: {
        'adminSettingSeminarRoom.roomName': '会議室名',
        'adminSettingSeminarRoom.roomNameEN': '会議室名（英語）',
        'adminSettingSeminarRoom.stimeGtEtime': '終了時間には開始時間以降の時間を指定してください。',
    },
};

export default lang;
